import { Image } from 'primereact/image';
import React, { useState, useEffect } from "react";
import { InputText } from "primereact/inputtext";
import { Checkbox } from "primereact/checkbox";
import Layout from "../../components/common/nav/initiator/nav.component";
import { Button } from 'primereact/button';
import { InputSwitch } from "primereact/inputswitch";
import { DataTable } from 'primereact/datatable';
import { Auth, DataStore, Predicates, SortDirection } from 'aws-amplify';
import { ValidateInitiatorRole, } from '../../helper/validateRole';
import { Column } from 'primereact/column';
import { Sidebar } from 'primereact/sidebar';
import { Tag } from 'primereact/tag';
import sideBarRight from "../../assets/images/sidebarright.svg"
import user1 from "../../assets/images/user1.svg"
import user2 from "../../assets/images/user2.svg"
import Editpopup from "../../components/popup/editpopup";
import { Dialog } from "primereact/dialog";
import Login from '../../setup/auth/login.component';
import sidebar from "../../assets/images/sidebarright.svg"
import { Dropdown } from 'primereact/dropdown';
import { TabView, TabPanel } from 'primereact/tabview';
import { Avatar } from 'primereact/avatar';
import { ConvertResponseForSelectWithRefCodedropdown, ConvertResponseForSelect } from '../../helper/commonfunctions';
import {
  InitiateClassifiedWeeklyAbsenceReport, InitiateClassifiedWeeklyAbsenceReportStatus, Employee, Schools, Subject,
  SixthPeriodAssignmentInitiateReport,
} from "../../models";
import w9DetailesPic from '../../assets/svg/w9details.svg'
import moment from "moment";
import { Link } from 'react-router-dom';
import AWS from "aws-sdk";
import awsmobile from "../../aws-exports";
import { Calendar } from 'primereact/calendar';
import empDetailsImg from '../../assets/images/applicationImg.png';
import { toast } from 'react-toastify';
import { Request_Status } from '../../helper/enum';
import { reactLocalStorage } from 'reactjs-localstorage';
import HtmlToPdf from '../../components/HtmlToPdf';
import ServiceAgreementPdf from '../../components/reportpdftemplate/serviceagreementpdf';
import '../../components/reportpdftemplate/base.min.css'
import '../../components/reportpdftemplate/fancy.min.css'
import '../../components/reportpdftemplate/main.css'
import PreviewAgreement from '../../../src/assets/images/stipend-form.jpg';
import Expand from '../../../src/assets/svg/expand.svg';


export default function ServiceAgreementInitiatorReportList() {
  const [StipendsFormFullScreen, setStipendsFormFullScreen] = useState(false);
  const [RejectReport, setRejectReport] = useState(false);
  const [RejectReport_Send, setRejectReport_Send] = useState(false);
  const [Report_Approved, setReport_Approved] = useState(false);

  //states start
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [allEmployeeDetails, setAllEmployeeDetails] = useState([]);
  const [selectedEmployeeDetails, setSelectedEmployeeDetails] = useState(null);
  const [empCodeList, setEmpCodeList] = useState([]);
  const [specificReportDetailsView, setSpecificReportDetailsView] = useState([]);
  const [specificReportDetailsEdit, setSpecificReportDetailsEdit] = useState([]);
  const [submitCount, setSubmitCount] = useState(0);
  const [approvedCount, setApprovedCount] = useState(0);
  const [rejectCount, setRejectCount] = useState(0);
  const [initiatorReportList, setInitiatorReportList] = useState([]);
  //states end
  const [fullViewEdit, setFullViewEdit] = useState(false);
  const [fullViewForView, setFullViewForView] = useState(false);
  const [visibleCreteReportPopup, setVisibleCreteReportPopup] = useState(false);
  const [showNextPopUp, setShowNextPopUp] = useState(false);
  const [confirmVisible2, setConfirmVisible2] = useState(false);
  const [showPreviewPopUp, setShowPreviewPopUp] = useState(false);
  const [groupName, setGroupName] = useState();
  const [accountCharge, setAccountCharged] = useState('');
  const [totalStaffingAllocationectedRole, setTotalStaffingAllocation] = useState('');
  let [userList, setUserList] = useState([]);
  const [subjectCode, setSubjectCodeList] = useState(null);
  const [value, setValue] = useState('');
  const [employeeId, setEmployeeId] = useState('');
  const [fteUtilized, setFteUtilized] = useState('');
  const [checked, setChecked] = useState(false);
  const [myaccountt, setProducts] = useState([]);
  const [isAuthenticated, userHasAuthenticated] = useState(true);
  const [visible, setVisible] = useState(false);
  const [visibleEdit, setVisibleEdit] = useState(false);
  const [confirmVisible, setConfirmVisible] = useState(false);
  const [position, setPosition] = useState('center');
  const [visibleRight, setVisibleRight] = useState(false);
  const [basicInfoPopUp, SetBasicInfoPopUp] = useState(true);
  const [weeklyAbsenceReports, setWeeklyAbsenceReports] = useState();
  const [weeklyAbsenceReportSubmitted, setWeeklyAbsenceReportSubmitted] = useState();
  const [weeklyAbsenceReportApproved, setWeeklyAbsenceReportApproved] = useState();
  const [weeklyAbsenceReportRejected, setWeeklyAbsenceReportRejected] = useState();
  const [weeklyAbsenceReportPending, setWeeklyAbsenceReportPending] = useState();
  const [activate, setActivate] = useState("");
  const [attchmentAndDetailes, SetAttchmentAndDetailes] = useState(false);
  const [termsAndConditions, SetTermsAndConditions] = useState(false);
  const [eddDetailes, SetEddDetailes] = useState(false);
  const [previewAndEdit, SetPreviewAndEdit] = useState(false);

  const footerContent = (
    <div className='text-center'>
      <button className='border border-[#1E1E1E] text-[#1E3E5A] px-4 py-2 rounded' onClick={() => { setConfirmVisible(false); setVisibleEdit(false) }}>Close</button>
    </div>
  );
  const footerContent1 = (
    <div className='text-center'>
      <button className='border border-[#1E1E1E] text-[#1E3E5A] px-4 py-2 rounded' onClick={() => { setConfirmVisible2(false); setShowNextPopUp(false); setVisibleCreteReportPopup(false); setShowPreviewPopUp(false); }}>Close</button>
    </div>
  );
  //_____popup

  //*state
  const [reportId, setReportId] = useState('');
  const [schoolName, setSchoolName] = useState('');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [status, setStatus] = useState('');
  const [schoolList, setSchoolList] = useState('');
  const [schoolSelect, setSelectedSchool] = useState('');
  const [partyDetailesPopup, setPartyDetailesPopUp] = useState(false);

  //*List
  const [employeeList, setEmployeeList] = useState([]);
  const [reportEmployeeList, setReportEmployeeList] = useState([]);
  const [users, SetUsersList] = useState([]);
  const [absentCodeListDropdown, setSubjectListDropdown] = useState();
  const loggedUserId = reactLocalStorage.get('loggedUserId');
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [assighnmentTitle, setAssighnmentTitle] = useState('');
  const [w9Detailes, SetW9Detailes] = useState(false);
  const currentDateTime = moment();
  
  const initiatordata = [
    {
    FromTItle:'1',
    EMPLID:'15850',
    EMPLNAME:'record1',
    PROSTITLE:'Lab Asst - Teacher',
    EFFECDATE:'05/07/2023',
    SALARYRATE:'$3000',
    RATEOFPAY:'$5000',
    REASON:'Insufficient Fund',
    FUNDING:'Dept of HR',
    ACCONO:'52452269874',
    STATUS:'Rejected',
    BUDGECODE:'0.0000 0 00007214',
  

  },
  {
    FromTItle:'1',
    EMPLID:'15850',
    EMPLNAME:'record1',
    PROSTITLE:'Lab Asst - Teacher',
    EFFECDATE:'05/07/2023',
    SALARYRATE:'$3000',
    RATEOFPAY:'$5000',
    REASON:'Insufficient Fund',
    FUNDING:'Dept of HR',
    ACCONO:'52452269874',
    STATUS:'Approved',
    BUDGECODE:'0.0000 0 00007214',
    
  },
  {
    FromTItle:'1',
    EMPLID:'15850',
    EMPLNAME:'record1',
    PROSTITLE:'Lab Asst - Teacher',
    EFFECDATE:'05/07/2023',
    SALARYRATE:'$3000',
    RATEOFPAY:'$5000',
    REASON:'Insufficient Fund',
    FUNDING:'Dept of HR',
    ACCONO:'52452269874',
    STATUS:'Rejected',
    BUDGECODE:'0.0000 0 00007214',
 
  },
  {
    FromTItle:'1',
    EMPLID:'15850',
    EMPLNAME:'record1',
    PROSTITLE:'Lab Asst - Teacher',
    EFFECDATE:'05/07/2023',
    SALARYRATE:'$3000',
    RATEOFPAY:'$5000',
    REASON:'Insufficient Fund',
    FUNDING:'Dept of HR',
    ACCONO:'52452269874',
    STATUS:'Submitted',
    BUDGECODE:'0.0000 0 00007214',
   
  },
  {
    FromTItle:'1',
    EMPLID:'15850',
    EMPLNAME:'record1',
    PROSTITLE:'Lab Asst - Teacher',
    EFFECDATE:'05/07/2023',
    SALARYRATE:'$3000',
    RATEOFPAY:'$5000',
    REASON:'Insufficient Fund',
    FUNDING:'Dept of HR',
    ACCONO:'52452269874',
    STATUS:'Submitted',
    BUDGECODE:'0.0000 0 00007214',
  },
  ]

  // status


  const statusBodyTemplate = (product) => {
    return <Tag value={product.STATUS} severity={getSeverity(product)}></Tag>;
};

const getSeverity = (product) => {
  switch (product.STATUS) {
      case 'Submitted':
          return 'success';

      case 'Approved':
          return 'warning';

      case 'Rejected':
          return 'danger';

      default:
          return null;
  }
};
//status end
  const [statuses] = useState(['Approved', 'Pending', 'Rejected', 'Submitted', 'Reviewed And Resubmited']);
  const statusItemTemplate = (option) => {
    return <Tag value={option} severity={TaskStatusSL(option)} />;
  };

  const TaskStatusSL = (product) => {
    switch (product.status) {

      case 'Rejected':
        return 'danger';

      case 'Pending':
        return 'warning';

      case 'Submitted':
        return 'info';

      case 'Approved':
        return 'success';

      case 'Approved (P)':
        return 'success';

      case 'Reviewed And Resubmited':
        return 'success';

      default:
        return null;
    }
  };

  const TaskStatusSLA = (product) => {
    // console.log("product", product.status);
    return <Tag value={product.status} severity={TaskStatusSL(product)}></Tag>;
  };

  const [PSAview, setPSAview] = useState(false);
  const [PSAedit, setPSAedit] = useState(false);

  const alljobactionContent = (row) => {
    return (
      <div className="flex justify-center w-full gap-2" >
        {/* <div className='cursor-pointer' onClick={() => setPSAview(true)}><i className="gusd-eye text-[#667085] text-[20px] font-meduim"></i></div> */}
        <div className='cursor-pointer'><i className="gusd-eye text-[#667085] text-[20px] font-meduim"></i></div>
        <div className='cursor-pointer' onClick={() => setPSAedit(true)}><i className="gusd-edit text-[#667085] text-[20px] font-meduim"></i></div>


        {/* {
          row.status === "Submitted" ? <Link to='#' className="py-2 px-2.5" onClick={() => onClickViewPopup(row, 'right')}><i className="gusd-eye text-[#667085] text-[20px] font-meduim"></i></Link> :
            row.status === "Approved" ? <Link to='#' className="py-2 px-2.5" onClick={() => onClickViewPopup(row, 'right')}><i className="gusd-eye text-[#667085] text-[20px] font-meduim"></i></Link> :
              row.status === "Reviewed & resubmitted" ? <Link to='#' className="py-2 px-2.5" onClick={() => onClickViewPopup(row, 'right')}><i className="gusd-eye text-[#667085] text-[20px] font-meduim"></i></Link> :
                <Link to='#' className="py-2 px-2.5"
                  onClick={() =>
                    onClickEditPopUp(row)
                  }><i className="gusd-edit text-[18px] text-[#667085] font-meduim"></i></Link>
        } */}
      </div>
    );
  };

  const statusRowFilterTemplate = (options) => {
    return (
      <Dropdown value={options.value} options={statuses} onChange={(e) => options.filterApplyCallback(e.value)} itemTemplate={statusItemTemplate} placeholder="Select" className="p-column-filter custDropdown" showClear style={{ minWidth: '7rem' }} />
    );
  };

  //* onclick view popup
  const onClickViewPopup = async (requestData, position) => {
    setPosition(position);
    setVisible(true);

    //set Data for View Popup
    let obj = {
      employee_id: requestData.employee_id,
      assighment_at: requestData.assighment_at,
      from_date: requestData.from_date,
      to_date: requestData.to_date,
      subject_area: requestData.subject_area,
      total_staffing_allocation: requestData.total_staffing_allocation,
      account_charged: requestData.account_charged,
      current_fte_utilized: requestData.current_fte_utilized,
    }
    setSpecificReportDetailsView(obj);
  }

  const onClickEditPopUp = async (requestData) => {
    setVisibleEdit(true)

    //set Data for View Popup
    let obj = {
      employee_id: requestData.employee_id,
      assighment_at: requestData.assighment_at,
      from_date: requestData.from_date,
      to_date: requestData.to_date,
      subject_area: requestData.subject_area,
      total_staffing_allocation: requestData.total_staffing_allocation,
      account_charged: requestData.account_charged,
      current_fte_utilized: requestData.current_fte_utilized,
    }
    setSpecificReportDetailsEdit(obj);

  }

  const toggleActive = () => {
    setActivate(activate === "actives" ? "" : "actives");
  };

  async function onLoad() {
    try {
      await Auth.currentSession();
      if (!ValidateInitiatorRole()) { userHasAuthenticated(false); }
    } catch (e) {
      userHasAuthenticated(false);
    }
  }

  const saveBasicInfo = async (type) => {

    if (selectedEmployee === null) { toast.error('Please Select Employee Id'); return; }
    else if (schoolSelect === '') { toast.error('Please Select Assignment At'); return; }
    else if (assighnmentTitle === '') { toast.error('Please enter Assighment Title'); return; }
    else if (startDate === null) { toast.error('Please enter From Date'); return; }
    else if (endDate === null) { toast.error('Please enter To Date'); return; }
    else if (subjectCode === null) { toast.error('Please enter To Date'); return; }

    var updatedSchoolId;

    //Save Basic Info

    //check type
    if (type === 'save') {
      var newSixthPeriodAssignmentInitiateReport = await DataStore.save(new SixthPeriodAssignmentInitiateReport({
        "assignment_title": assighnmentTitle,
        "employee_id": selectedEmployee.name,
        "assighment_at": schoolSelect.name,
        "from_date": moment(startDate).format("YYYY-MM-DD"),
        "to_date": moment(endDate).format("YYYY-MM-DD"),
        "subject_area": subjectCode.name,
        "total_staffing_allocation": totalStaffingAllocationectedRole,
        "account_charged": accountCharge,
        "current_fte_utilized": fteUtilized,
        "status": Request_Status.P,
      })
      );
    } else {
      //other wise status submit
      var newSixthPeriodAssignmentInitiateReport = await DataStore.save(new SixthPeriodAssignmentInitiateReport({
        "assignment_title": assighnmentTitle,
        "employee_id": selectedEmployee.name,
        "assighment_at": schoolSelect.name,
        "from_date": moment(startDate).format("YYYY-MM-DD"),
        "to_date": moment(endDate).format("YYYY-MM-DD"),
        "subject_area": subjectCode.name,
        "total_staffing_allocation": totalStaffingAllocationectedRole,
        "account_charged": accountCharge,
        "current_fte_utilized": fteUtilized,
        "submited_by": loggedUserId,
        "submited_at": moment(currentDateTime).format("YYYY-DD-MM"),
        "status": Request_Status.S,
      })
      );
    }

    updatedSchoolId = newSixthPeriodAssignmentInitiateReport.id;

    if (newSixthPeriodAssignmentInitiateReport) {
      toast.success('Data Added Successfully.');
      BindList();
    }
  }

  AWS.config.update({
    accessKeyId: process.env.REACT_APP_AWS_AccessKeyId,
    secretAccessKey: process.env.REACT_APP_AWS_SecretAccessKey,
    region: process.env.REACT_APP_AWS_Region,
  });


  //*get getEmployeeResponse
  const getEmployeeResponse = (id) => {
    let _employeeList = [...employeeList];
    var returnRecord = _employeeList.find(o => o.id === String(id));
    if (returnRecord !== null && returnRecord !== undefined) { return returnRecord; } else { return null; }
  }


  //Get Weekly Absence Report-Classified List
  const BindList = async () => {


    //fetch all SixthPeriodAssignmentInitiateReport table data
    try {
      const sixPeriodInitiatorReportResponse = await DataStore.query(SixthPeriodAssignmentInitiateReport, Predicates.ALL, {
        sort: s => s.assignment_title(SortDirection.ASCENDING)
      });
      if (sixPeriodInitiatorReportResponse) {

        console.log("data is bbbbbbbbbb:-", sixPeriodInitiatorReportResponse);
        //change data format according to UI.
        let submitCount = 0;
        let approvedCount = 0;
        let rejectCount = 0;
        let finalData = [];
        sixPeriodInitiatorReportResponse.map((currentItem, i) => {

          //change format of period attribute
          const startDate = new Date(currentItem.from_date);
          const endDate = new Date(currentItem.to_date);

          const dateFormatter = new Intl.DateTimeFormat('en-US', { day: 'numeric', month: 'short', year: 'numeric' });
          const formattedStartDate = dateFormatter.format(startDate);
          const formattedEndDate = dateFormatter.format(endDate);
          const period = `${formattedStartDate} to ${formattedEndDate}`;

          let obj = {
            srNo: i + 1,
            assignmentTitle: currentItem.assignment_title,
            period: period,
            submittedOn: currentItem.submited_at,
            status: currentItem.status.charAt(0).toUpperCase() + currentItem.status.slice(1).toLowerCase(),
            // remark:currentItem.remark

            employee_id: currentItem.employee_id,
            assighment_at: currentItem.assighment_at,
            from_date: currentItem.from_date,
            to_date: currentItem.to_date,
            subject_area: currentItem.subject_area,
            total_staffing_allocation: currentItem.total_staffing_allocation,
            account_charged: currentItem.account_charged,
            current_fte_utilized: currentItem.current_fte_utilized
          }

          //specific report category get approved,submitted and rejected count

          if (currentItem.status === 'SUBMITTED') {
            submitCount++;
          } else if (currentItem.status === 'APPROVED') {
            approvedCount++;
          } else if (currentItem.status === 'REJECTED') {
            rejectCount++;
          }
          setSubmitCount(submitCount);
          setApprovedCount(approvedCount);
          setRejectCount(rejectCount);

          finalData.push(obj);
        })

        setInitiatorReportList(finalData)
      }
    } catch (error) {
      console.log('Error for bindList', error);
    }







    var SubjectCodeResponses = await DataStore.query(Subject, Predicates.ALL, {
      sort: s => s.name(SortDirection.ASCENDING)
    });
    setSubjectCodeList(SubjectCodeResponses)
    var myArray = []; myArray = ConvertResponseForSelectWithRefCodedropdown(SubjectCodeResponses); setSubjectListDropdown(myArray);


    var SchoolResponses = await DataStore.query(Schools, Predicates.ALL, {
      sort: s => s.name(SortDirection.ASCENDING)
    });
    var schoolArray = []; schoolArray = ConvertResponseForSelect(SchoolResponses); setSchoolList(schoolArray);


    var employeeList = await DataStore.query(Employee, Predicates.ALL, {
      sort: s => s.employee_name(SortDirection.ASCENDING)
    });
    setEmployeeList(employeeList)

    const cognito = new AWS.CognitoIdentityServiceProvider();
    var params =
    {
      UserPoolId: awsmobile.aws_user_pools_id,
      Limit: 60
    };
    cognito.listUsers(params, (err, data) => {
      if (err) {
        console.log(err);
      } else {
        // console.log(data)
        SetUsersList(data.Users);
      }
    });

    loadAbsenceReport();
  }

  //initiate new report
  const initiateNewReport = async () => {
    //fetch employee table data
    try {
      const employeeResponse = await DataStore.query(Employee, Predicates.ALL, {
        sort: s => s.employee_code(SortDirection.ASCENDING)
      });
      if (employeeResponse) {
        console.log("employeeResponse:-", employeeResponse);

        //set employee list
        let finalEmpList = [];
        employeeResponse.map((currentItem) => {
          let obj = { name: currentItem.employee_code, code: currentItem.id };
          finalEmpList.push(obj);
        })
        setEmpCodeList(finalEmpList);
        setAllEmployeeDetails(employeeResponse);
        // then show popup
        setShowNextPopUp(true);

      }
    } catch (error) {
      console.log('Error retrieving posts', error);
    }
  }

  //*loadAbsenceReport
  const loadAbsenceReport = async () => {

    //*Set Weekly Absence Report-Classified List
    var weeklyAbsenceReport = await DataStore.query(InitiateClassifiedWeeklyAbsenceReport)
    let newResponse = [];
    for (let i = 0; i < weeklyAbsenceReport.length; i++) {
      let schoolName = "";
      let workDuration = "";
      let submittedOn = "";
      let status = "";
      let remark = "";

      //*Work Duration
      if (weeklyAbsenceReport[i].from_date && weeklyAbsenceReport[i].to_date) {
        let fromDate = moment(weeklyAbsenceReport[i].from_date, 'YYYY-DD-MM').format('Do');
        let toDate = moment(weeklyAbsenceReport[i].to_date, 'YYYY-DD-MM').format("Do MMMM'YY");
        workDuration = fromDate + " - " + toDate
      }
      else { workDuration = "-" }

      //*submitted On
      if (weeklyAbsenceReport[i].status_date_time !== null && weeklyAbsenceReport[i].status_date_time !== undefined) {
        submittedOn = weeklyAbsenceReport[i].status_date_time !== null ? moment(weeklyAbsenceReport[i].status_date_time).format("Do MMMM'YY") : "-";
      } else { submittedOn = "-" }

      // //*School Name
      if (weeklyAbsenceReport[i].school_id !== null && weeklyAbsenceReport[i].school_id !== undefined) {
        var schoolResponses = await DataStore.query(Schools, (c) => c.id.eq(weeklyAbsenceReport[i].school_id));
        if (schoolResponses.length > 0) { schoolName = schoolResponses[0].name; } else { schoolName = ""; }
      } else { schoolName = ""; }

      if (weeklyAbsenceReport[i].payroll_status !== null && weeklyAbsenceReport[i].payroll_status === InitiateClassifiedWeeklyAbsenceReportStatus.PAYROLL_ACCEPTED) {
        status = "Approved (P)"; remark = "-";
      } else if (weeklyAbsenceReport[i].payroll_status !== null && weeklyAbsenceReport[i].payroll_status === InitiateClassifiedWeeklyAbsenceReportStatus.PAYROLL_REJECTED) {
        status = "Rejected (P)"; remark = weeklyAbsenceReport[i].payroll_remark;
      } else if (weeklyAbsenceReport[i].approver_status !== null && weeklyAbsenceReport[i].approver_status === InitiateClassifiedWeeklyAbsenceReportStatus.APPROVAL_ACCEPTED) {
        status = "Approved (A)"; remark = "-";
      } else if (weeklyAbsenceReport[i].approver_status !== null && weeklyAbsenceReport[i].approver_status === InitiateClassifiedWeeklyAbsenceReportStatus.APPROVAL_REJECTED) {
        status = "Rejected (A)"; remark = weeklyAbsenceReport[i].approver_remark;
      } else if (weeklyAbsenceReport[i].payroll_status === null && weeklyAbsenceReport[i].approver_status === null && weeklyAbsenceReport[i].status === InitiateClassifiedWeeklyAbsenceReportStatus.SUBMITTED) {
        status = "Submitted"; remark = "-";
      } else if (weeklyAbsenceReport[i].payroll_status === null && weeklyAbsenceReport[i].approver_status === null && weeklyAbsenceReport[i].status === InitiateClassifiedWeeklyAbsenceReportStatus.OPEN) {
        status = "Pending"; remark = "-";
      }

      newResponse.push({
        "id": weeklyAbsenceReport[i].id,
        "user_id": weeklyAbsenceReport[i].user_id, "status": status, "school_id": weeklyAbsenceReport[i].school_id, "from_date": weeklyAbsenceReport[i].from_date,
        "to_date": weeklyAbsenceReport[i].to_date, "status_date_time": weeklyAbsenceReport[i].status_date_time, "approver_remark": weeklyAbsenceReport[i].approver_remark, "payroll_remark": weeklyAbsenceReport[i].payroll_remark !== null ? weeklyAbsenceReport[i].payroll_remark : "-",
        "schoolName": schoolName, "workDuration": workDuration, "submittedOn": submittedOn, "remark": remark, "createdAt": weeklyAbsenceReport[i].createdAt, "updatedAt": weeklyAbsenceReport[i].updatedAt,
      })

      if (i === weeklyAbsenceReport.length - 1) {

        setWeeklyAbsenceReports(newResponse)
        //SubmittedCount
        const submittedCount = newResponse.filter(obj => obj.status === "Submitted")
        setWeeklyAbsenceReportSubmitted(submittedCount.length)

        //SubmittedCount
        const approvedCountP = newResponse.filter((obj) => obj.status === "Approved (P)");
        const approvedCountA = newResponse.filter((obj) => obj.status === "Approved (A)");
        let approvedCount = approvedCountP.length + approvedCountA.length
        setWeeklyAbsenceReportApproved(approvedCount)

        //RejectedCount
        const rejectedCountP = newResponse.filter((obj) => obj.status === "Rejected (P)");
        const rejectedCountA = newResponse.filter((obj) => obj.status === "Rejected (A)");
        const rejectedCount = rejectedCountP.length + rejectedCountA.length
        setWeeklyAbsenceReportRejected(rejectedCount)

        //RejectedCount
        const pendingCount = newResponse.filter((obj) => obj.status === "Pending");
        setWeeklyAbsenceReportPending(pendingCount.length)
      }
    }
  }

  useEffect(() => {
    // onLoad();
    BindList();
  }, []);


  return isAuthenticated ? (
    <>
      <Layout pageTitle="Report" activeMenu="Initiator">
        <div className="report-wrapper pt-24 md:pt-28 xl:pt-[2.083vw]">
          <div className="flex justify-end visible lg:hidden">
            <Button icon="pi pi-bars" onClick={toggleActive} style={{ color: '#308B90', background: '#ffffff00', border: '1', borderColor: '#308B90', width: '38px', padding: '6px 0', borderRadius: '4px' }}></Button>

          </div>
          <div className="grid grid-cols-1 md:grid-cols-12 gap-3 xl:gap-[1.250vw] pb-5">
            <div className="relative z-10 col-span-12" data-aos="fade-down" data-aos-duration="800">
              <div className="bg-[#fff] box-shadow-2 radius8 border border-[#E4E7EC]" >
                <div className="flex items-center justify-between p-[20px] xl:px-[1.250vw] xl:py-[0.990vw] border-b border-[#E4E7EC] ">
                  <div className="text-[22px] xl:text-[0.938vw]  text-[#101828] font-medium">Personnel Actions</div>

                  {/* <div className="flex gap-2 xl:gap-[0.990vw] items-center">
                    <Link to='/personnelactionsreports/Initiatenewform' className="inline-block text-[#98A2B3] font-medium min-w-[170px] text-center bg-[#E4E7EC] py-[8px] px-[14px] border border-[#D0D5DD] rounded-[8px]">
                      <i className="gusd-close mx-1.5 "></i> Reject</Link>
                      <Link to='' className="inline-block min-w-[170px] text-[#98A2B3] font-medium text-center bg-[#E4E7EC] py-[8px] px-[14px] border border-[#D0D5DD] rounded-[8px]">
                      <i className="gusd-check mx-1.5 "></i> Approve</Link>
                    <Link to=""> <i className="gusd-expand"></i></Link>
                  </div> */}
                </div>

                <div className='w-full border-b border-[#D0D5DD]'>
                <div className='flex items-center'>
                    <Link to={'/personnelactionsreports'} className='text-[#6c757d] bg-white border-b border-[#dee2e6] p-[1.25rem] inline-block font-[700]'>Initiate Reports</Link>
                    <Link to={'/personnelactionsreports/approver'} className='text-[#6366F1] font-[700] bg-white border-b border-[#6366F1] p-[1.25rem] inline-block'>Requested Reports</Link>
                </div>
                
                </div>

                <div>
                <div className="initiator approver">
                <DataTable className="custpaginator custIcons custmBtnTable custTable " scrollable value={initiatordata} paginator responsiveLayout="scroll" paginatorTemplate="PrevPageLink PageLinks NextPageLink" rows={11}>
                    <Column field="FromTitle" header="Form Title" sortable style={{ minWidth: '8rem' }}></Column>
                    <Column field="EMPLID" header="Employee ID"  sortable style={{ minWidth: '8rem' }}></Column>
                    <Column field="EMPLNAME" header="Employee Name" style={{ minWidth: '10rem' }} sortable></Column>
                    <Column field="PROSTITLE" header="Position Title (To - From)" style={{ minWidth: '14rem' }} sortable></Column>
                    <Column field="EFFECDATE" header="Effective Dates |(From - To)"  style={{ minWidth: '14rem' }} sortable ></Column>
                    <Column field="SALARYRATE" header="Salary Rate" sortable style={{ minWidth: '8rem' }}></Column>
                    <Column field="RATEOFPAY" header="Rate of Pay (Note to Exceed)" sortable style={{ minWidth: '14rem' }}></Column>
                    <Column field="REASON" header="Reason" sortable style={{ minWidth: '5rem' }}></Column>
                    <Column field="FUNDING" header="Funding Source" sortable style={{ minWidth: '10rem' }}></Column>
                    <Column field="ACCONO" header="Account Number" sortable style={{ minWidth: '10rem' }}></Column>
                    <Column field="BUDGECODE" header="Budget Code" sortable style={{ minWidth: '8rem' }}></Column>
                    <Column field="STATUS" header="Status" sortable body={statusBodyTemplate} style={{ minWidth: '5rem' }}></Column>
                    <Column field="action" header="Action" align='center' body={alljobactionContent} style={{ minWidth: '6rem' }}></Column>
                  </DataTable>
                </div>
                </div>

                {/* confirmation dialog */}

                <Dialog header="" visible={confirmVisible} style={{ width: '30vw' }} onHide={() => { setConfirmVisible(false); setVisibleEdit(false); }} footer={footerContent}>
                  <p className="m-0 text-[#0487C8]">
                    <i className='pi pi-check-circle mr-2'></i>
                    <span className='font-medium text-[18px]'>Your changes has been saved in this report</span>
                  </p>
                </Dialog>
                {/* edit popup end */}

              </div>

              <Sidebar visible={visibleRight} position="right" onHide={() =>
                setVisibleRight(false)} style={{ width: '35vw' }} className="customesidebar1 responsivepoup">
                <Editpopup popupstate={() => setVisibleRight(false)}
                  fromDate={fromDate}
                  toDate={toDate}
                  schoolName={schoolName}
                  reportEmployeeList={reportEmployeeList}
                  status={status}
                  reportId={reportId}
                  bindList={() => loadAbsenceReport()}
                  type={"Initior"}
                />

              </Sidebar>
            </div>
          </div>
        </div>

        <Sidebar className='PSAviewPopup' visible={PSAview} position="right" onHide={() => setPSAview(false)} style={{width:'60vw',background:'#F5F6F7'}}>
        <div className='xl:py-[1.667vw] py-[28px] xl:px-[1.250vw] px-[20px]'>
          <div className='cursor-pointer mb-[20px]' onClick={() => setPSAview(false)}><Image src={sideBarRight} alt="user" width="20" height="20" /></div>
          
          <div className='text-black font-bold xl:text-[1.406vw] text-[25px]'>GLENDALE UNIFIED SCHOOL DISTRICT</div>
          <div className='text-black font-normal xl:text-[0.938vw] text-[16px]'>Request For Approval - Personal Service Agreement</div>

        <div className='xl:p-[1.250vw] p-[20px] bg-[#F5F6F7] flex items-center justify-between mt-[20px]'>
        <div className='flex items-center space-x-2 text-[#000000] font-medium xl:text-[1.250vw] text-[20px]'>
        <span className='gusd-file-icon w-4 h-4 inline-block'></span><span>Stipend Form.pdf</span>
        </div>
        </div>

        <div className='xl:p-[1.250vw] p-[20px] bg-[#F5F5F5] rounded-bl rounded-br'>
        <div className='lg:h-[25vw] h-[450px] overflow-auto'>
        <Image src={PreviewAgreement} width={"942"} height={"1160"} alt='preview-agreement' />
        </div>
        </div>

        <div className='grid grid-cols-2 mt-[20px] gap-[14px]'>
          <div><Link to={''} className='text-[#344054] font-medium text-xs xl:text-[0.833vw] bg-white border border-[#D0D5DD] text-center flex items-center justify-center gap-x-2 xl:py-[0.521vw] py-[6px] xl:px-[0.833vw] px-[12px] rounded-lg'><i className='gusd-print-outline'></i><span>Print</span></Link></div>
          <div><Link to={''} className='text-[#FFFFFF] font-medium text-xs xl:text-[0.833vw] bg-[#113699] border border-[#113699] text-center flex items-center justify-center gap-x-2 xl:py-[0.521vw] py-[6px] xl:px-[0.833vw] px-[12px] rounded-lg'><i className='Download_WhiteIcon'></i><span>Download</span></Link></div>
        </div>
        
        </div>
        </Sidebar>


        <Sidebar className='PSAviewPopup' visible={PSAedit} position="right" onHide={() => setPSAedit(false)} style={{width:'38vw',background:'#F5F6F7'}}>
        <div className='xl:py-[1.667vw] py-[28px] xl:px-[1.250vw] px-[20px] lg:space-y-[1.250vw] space-y-2 h-full'>
          <div className="relative h-full">
          {/*col*/}
          <div className='cursor-pointer mb-[15px]' onClick={() => setPSAedit(false)}><i className='gusd-close-sidebar text-[24px]'></i></div>
          {/*col*/}
          <div>
            <div className='text-[#113699] font-semibold text-sm xl:text-[0.938vw]'>Glendale Unified School District</div>
            <div className='text-[#344054] font-normal text-xs xl:text-[0.677vw]'>Personnel Action</div>
          </div>
          <div className="xl:h-[36.250vw] 2xl:h-[38.250vw] lg:h-[28.250vw] overflow-auto">
            <div className='status-list'>
            <div className='flex justify-between'>
              <div className='text-[#344054] text-[14px]'>Status</div>
              <div className='text-[#FF7F01] text-[12px] bg-[#FFF2E5] py-[4px] px-[8px] rounded-[18px]'>
              <i className='gusd-dot text-[10px] mr-1'></i> Pending for Approval
              </div>
            </div>
            <div className='flex justify-between'>
              <div className='text-[#344054] text-[14px]'>Type</div>
              <div className='text-[#344054] text-[14px] font-semibold'>Certificated</div>
            </div>
            <div className='flex justify-between'>
              <div className='text-[#344054] text-[14px]'>Board Meeting Date</div>
              <div className='text-[#344054] text-[14px] font-semibold'>16/05/2023</div>
            </div>
            <div className='flex justify-between'>
              <div className='text-[#344054] text-[14px]'>Personnel Report No</div>
              <div className='text-[#344054] text-[14px] font-semibold'>84161519846</div>
            </div>
            <div className='flex justify-between'>
              <div className='text-[#344054] text-[14px]'>Location</div>
              <div className='text-[#344054] text-[14px] font-semibold'>Texas, USA</div>
            </div>
            <div className='flex justify-between'>
              <div className='text-[#344054] text-[14px]'>Action to be Taken</div>
              <div className='text-[#344054] text-[14px] font-semibold'>Lorem Ipsum</div>
            </div>
            </div>
            <div className='bg-white mt-[24px] rounded-[8px] p-[8px]'>
            <div className="flex justify-end">
                    <a
                      href="/personnelactionsreports/Initiatelist"
                      className="text-[#113699] font-medium text-[14px] pb-3"
                    >
                      <i className="pi pi-calendar mr-1 mt-2"></i>View Full Screen{" "}
                    </a>
                  </div>
              <div className='mt-2 popup_action_table'>
              <table class="w-full">
                  <thead>
                    <tr>
                      <th>Employee ID </th>
                      <th>Employee Name</th>
                      <th>Position Title (To - From)</th>
                      <th>Salary Rate</th>
                      <th>Funding Souce</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>ABCD123</td>
                      <td>Kristin Watson</td>
                      <td>Teacher - Lab Asst</td>
                      <td>$ 2,200</td>
                      <td>Dept. of HR</td>
                    </tr>
                    <tr>
                      <td>ABCD123</td>
                      <td>Kristin Watson</td>
                      <td>Teacher - Lab Asst</td>
                      <td>$ 2,200</td>
                      <td>Dept. of HR</td>
                    </tr>
                    <tr>
                      <td>ABCD123</td>
                      <td>Kristin Watson</td>
                      <td>Teacher - Lab Asst</td>
                      <td>$ 2,200</td>
                      <td>Dept. of HR</td>
                    </tr>
                    <tr>
                      <td>ABCD123</td>
                      <td>Kristin Watson</td>
                      <td>Teacher - Lab Asst</td>
                      <td>$ 2,200</td>
                      <td>Dept. of HR</td>
                    </tr>
                    <tr>
                      <td>ABCD123</td>
                      <td>Kristin Watson</td>
                      <td>Teacher - Lab Asst</td>
                      <td>$ 2,200</td>
                      <td>Dept. of HR</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
        
          </div>
          {/*col*/}
          <div className='custm_InputSwitch flex items-center justify-center text-[#1E3E5A] font-medium text-sm gap-2 mt-[24px] my-3'>
          <InputSwitch checked={checked} onChange={(e) => setChecked(e.value)} />
          <span>Add Signature<span class="text-[red] pl-0.2">*</span></span>
          </div>
          {/*col*/}
          <div className='absolute bottom-0 left-0 right-0'>
         
          <div className='grid grid-cols-3 gap-2'>
            <div className='text-[#344054] font-medium text-sm text-center xl:py-[0.521vw] py-[8px] xl:px-[0.781vw] px-[14px] border border-[#D0D5DD] bg-white Shadow_xs rounded-lg space-x-2 cursor-pointer'>
            <i class="gusd-print-outline"></i><span>Cancel</span></div>
            <div className='text-[#D92D20] font-medium text-sm text-center xl:py-[0.521vw] py-[8px] xl:px-[0.781vw] px-[14px] border border-[#D0D5DD] bg-white Shadow_xs rounded-lg space-x-2 cursor-pointer'>
            <i class="pi pi-times"></i><span>Reject</span></div>
            <div className='text-[#039855] font-medium text-sm text-center xl:py-[0.521vw] py-[8px] xl:px-[0.781vw] px-[14px] border border-[#D0D5DD] bg-white Shadow_xs rounded-lg space-x-2 cursor-pointer'>

            <i class="pi pi-check"></i><span>Approve</span></div>
           
          </div>
          {/* <div className='grid grid-cols-3 gap-2'>
            <div className='text-[#344054] font-medium text-sm text-center xl:py-[0.521vw] py-[8px] xl:px-[0.781vw] px-[14px] border border-[#D0D5DD] bg-white Shadow_xs rounded-lg space-x-2 cursor-pointer'><i className='gusd-close-circle text-base'></i><span>Cancel</span></div>
            <div className='text-[#D92D20] font-medium text-sm text-center xl:py-[0.521vw] py-[8px] xl:px-[0.781vw] px-[14px] border border-[#D0D5DD] bg-white Shadow_xs rounded-lg space-x-2 cursor-pointer btn-deactivate' onClick={() => setRejectReport(true)}><i className='gusd-close'></i><span>Reject</span></div>
            <div className='text-[#039855] font-medium text-sm text-center xl:py-[0.521vw] py-[8px] xl:px-[0.781vw] px-[14px] border border-[#D0D5DD] bg-white Shadow_xs rounded-lg space-x-2 cursor-pointer' onClick={() => setReport_Approved(true)}><i className='pi pi-check'></i><span>Approve</span></div>
          </div> */}
          </div>
          </div>
        </div>
        </Sidebar>

        <Dialog header="Header" className='RejectReport' visible={RejectReport} style={{ width: '30vw' }} onHide={() => setRejectReport(false)}>
                <div className='p-[22px] space-y-[14px]'>
                  {/*col*/}
                  <div>
                    <div className='text-[#101828] font-bold text-base -tracking-[0.36px]'>Reject Report</div>
                  </div>
                  {/*col*/}
                  <div className='space-y-1'>
                  <div className='text-[#344054] font-medium text-xs'>Enter the reason for rejection<span className="text-[red] pl-0.2">*</span></div>
                  <InputText value={value} onChange={(e) => setValue(e.target.value)} placeholder='Enter the Reason for Rejection' style={{border:'1px', borderStyle:"solid", borderRadius:'5px', borderColor:"#E4E7EC", background:"#fff", width:'100%'}} />
                  </div>
                  {/*col*/}
                  <div className='flex items-center justify-center'>
                    <div className='text-white bg-[#113699] py-2 px-4 text-center rounded-lg w-[150px] cursor-pointer' onClick={() => setRejectReport_Send(true)}>Send</div>
                  </div>
                  {/*col*/}
                </div>
            </Dialog>

            <Dialog header="Header" className='RejectReport' visible={RejectReport_Send} style={{ width: '30vw' }} onHide={() => setRejectReport_Send(false)}>
                <div className='p-[22px] space-y-[14px]'>
                  {/*col*/}
                  <div>
                    <div className='text-[#101828] font-bold text-base -tracking-[0.36px]'>Reject Report</div>
                  </div>
                  {/*col*/}
                  <div className='space-y-1'>
                  <div className='text-[#249144] font-normal text-base'>Message sent successfully!</div>
                  <InputText disabled value={value} onChange={(e) => setValue(e.target.value)} placeholder='Information Missing for  "David", Please review and resubmit.' style={{border:'1px', borderStyle:"solid", borderRadius:'5px', borderColor:"#F2F4F7", background:"#F2F4F7", width:'100%'}} />
                  </div>
                  {/*col*/}
                  <div className='flex items-center justify-center'>
                    <div className='text-white bg-[#113699] py-2 px-4 text-center rounded-lg w-[150px] cursor-pointer' onClick={() => setRejectReport_Send(false)}>ok</div>
                  </div>
                  {/*col*/}
                </div>
            </Dialog>

            <Dialog header="Header" className='RejectReport' visible={Report_Approved} style={{ width: '30vw' }} onHide={() => setReport_Approved(false)}>
                <div className='p-[22px] space-y-[14px]'>
                  <div className='flex justify-end'>
                  <div className='text-[#667085] text-sm cursor-pointer' onClick={() => setReport_Approved(false)}><i className='gusd-close'></i></div>
                  </div>
                  <div className='flex items-center justify-center'>
                  <div className='text-[#0487C8] font-medium text-lg flex items-center gap-2'><span className='right-rounded block w-[20px] h-[20px]'></span><span>Selected report was Approved</span></div>
                  </div>
                  {/*col*/}
                  <div className='flex items-center justify-center'>
                    <div className='text-[#1E3E5A] border border-[#C8C8C8] py-2 px-4 text-center rounded-lg cursor-pointer' onClick={() => setReport_Approved(false)}>Close</div>
                  </div>
                  {/*col*/}
                </div>
            </Dialog>

            <Sidebar className='PSAviewPopup' visible={StipendsFormFullScreen} position="right" onHide={() => setStipendsFormFullScreen(false)} style={{width:'60vw',background:'#F5F6F7'}}>
        <div className='xl:py-[1.667vw] py-[28px] xl:px-[1.250vw] px-[20px]'>
          <div className='cursor-pointer mb-[20px]' onClick={() => setStipendsFormFullScreen(false)}><Image src={sideBarRight} alt="user" width="20" height="20" /></div>

        <div className='xl:p-[1.250vw] p-[20px] bg-[#F5F6F7] flex items-center justify-between mt-[20px]'>
        <div className='flex items-center space-x-2 text-[#000000] font-medium xl:text-[1.250vw] text-[20px]'>
        <span className='gusd-file-icon w-4 h-4 inline-block'></span><span>Stipend Form.pdf</span>
        </div>
        <div className='text-[#113699] font-medium text-xs flex items-center gap-2 cursor-pointer' onClick={() => setStipendsFormFullScreen(false)}><span className='Exit_Full_Screen block w-[18px] h-[18px]'></span><span>Exit Full Screen</span></div>
        </div>

        <div className='xl:p-[1.250vw] p-[20px] bg-[#F5F5F5] rounded-bl rounded-br'>
        <div className='lg:h-[25vw] h-[450px] overflow-auto'>
        <Image src={PreviewAgreement} width={"942"} height={"1160"} alt='preview-agreement' />
        </div>
        </div>

        {/*col*/}
        <div className='custm_InputSwitch flex items-center text-[#1E3E5A] font-medium text-sm gap-2 py-[20px]'>
          <InputSwitch checked={checked} onChange={(e) => setChecked(e.value)} />
          <span>Add e Signature</span>
          </div>
          {/*col*/}

        <div className='grid grid-cols-3 gap-2'>
            <div className='text-[#344054] font-medium text-sm text-center xl:py-[0.521vw] py-[8px] xl:px-[0.781vw] px-[14px] border border-[#D0D5DD] bg-white Shadow_xs rounded-lg space-x-2 cursor-pointer'><i className='gusd-close-circle text-base'></i><span>Cancel</span></div>
            <div className='text-[#D92D20] font-medium text-sm text-center xl:py-[0.521vw] py-[8px] xl:px-[0.781vw] px-[14px] border border-[#D0D5DD] bg-white Shadow_xs rounded-lg space-x-2 cursor-pointer' onClick={() => setRejectReport(true)}><i className='gusd-close'></i><span>Reject</span></div>
            <div className='text-[#039855] font-medium text-sm text-center xl:py-[0.521vw] py-[8px] xl:px-[0.781vw] px-[14px] border border-[#D0D5DD] bg-white Shadow_xs rounded-lg space-x-2 cursor-pointer btn-deactivate' onClick={() => setReport_Approved(true)}><i className='pi pi-check'></i><span>Approve</span></div>
          </div>
        
        </div>
        </Sidebar>

      </Layout >
    </>
  ) : (
    <Login sessionExpired={1} />
  );
}